import React from 'react';

// A last-resort safety net: if anything in the app throws during render
// (a bug, a bad cached state, an unexpected API shape), show a recoverable
// screen instead of a silent blank page with no way forward.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error in app:', error, errorInfo);
  }

  handleReset = () => {
    // Clear anything that might be causing a persistent bad state (stale
    // saved view, corrupted cached objects, etc.) and start fresh.
    localStorage.removeItem('lastView');
    localStorage.removeItem('lastWorkshop');
    localStorage.removeItem('lastWorkshopTab');
    localStorage.removeItem('lastWritingSession');
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
          <div className="bg-white rounded-lg shadow-md p-8 max-w-md w-full text-center">
            <h1 className="text-lg font-bold text-gray-900 mb-2">Something went wrong</h1>
            <p className="text-sm text-gray-600 mb-6">
              The app hit an unexpected error. Resetting your local session usually fixes this.
            </p>
            <button
              onClick={this.handleReset}
              className="w-full bg-[#01006A] text-white py-2 rounded-lg hover:bg-[#010059] text-sm font-medium"
            >
              Reset and Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
